Ext.define('SA.view.ReleaseSelector', {
    alias: 'widget.release-selector',
    extend: 'Ext.Component',

    baseCls: 'sa-release-selector',

    tpl: [
        '<div class="sa-release-selector-header">',
            '<div>Census Geographic Years</div>',
            '<div class="sa-release-selector-ranges-header">Year(s) of Data Available</div>',
        '</div>',
        '<div class="sa-release-selector-body">',
            '<tpl for=".">',
                '<div data-value="{release}" class="sa-release-selector-item <tpl if="isSelected">sa-release-selector-item-selected</tpl>">',
                    '<div class="sa-release-selector-item-radio">',
                        '<span class="sa-release-selector-radio-button"></span>',
                        '<span class="sa-release-selector-radio-label">{censusReleaseRange}</span>',
                    '</div>',
                    '<div class="sa-release-selector-item-ranges">',
                        '<tpl for="editionRanges">',
                            '<div class="<tpl if="isProjection">sa-release-selector-range-projection</tpl>">',
                                '{range}',
                            '</div>',
                        '</tpl>',
                    '</div>',
                '</div>',
            '</tpl>',
        '</div>'
    ],

    beforeRender() {
        this.update(this.getTplData());

        this.callParent();
    },

    getSelectedItemEl() {
        return this.el.down('.sa-release-selector-item-selected', true);
    },

    getSelectedRelease() {
        return Number(this.getSelectedItemEl().getAttribute('data-value'));
    },

    getTplData() {
        var currentYear = SA.System.getYear(),
            selectedRelease = this.selectedRelease,
            country = SA.Country.get(this.country),
            editionRangesByRelease = country.getEditionRangesByCensusRelease(),
            sortLatestFirst = (a, b) => b.release - a.release,
            result = editionRangesByRelease.map(getItemTplData).sort(sortLatestFirst);

        result.shift(); 

        return result;

        function getItemTplData({censusRelease: release, ranges}) {
            return {
                release,
                isSelected: release == selectedRelease,
                censusReleaseRange: country.getCensusReleaseRange(Number(release)).join('–'),

                editionRanges: ranges.map(([start, end]) => {
                    return {
                        isProjection: start > currentYear,
                        range: start === end ? start : `${start} to ${end}`
                    };
                })
            };
        }
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onItemClick, this, {delegate: '.sa-release-selector-item'});
    },

    onItemClick(ev, el) {
        Ext.fly(this.getSelectedItemEl()).removeCls('sa-release-selector-item-selected');
        Ext.fly(el).addCls('sa-release-selector-item-selected');
    },

    setCountryAndSelectedRelease({country, selectedRelease}) {
        this.country = country;
        this.selectedRelease = selectedRelease;
    }
});